<template>
  <div class="address-form-container">
    <van-icon name="arrow-left" class="arrow-left" @click="handleBack" />
    <div class="title">
      {{ type === "add" ? "新增收货地址" : "编辑收货地址" }}
    </div>
    <van-form class="address-form" ref="formRef" :show-error="false">
      <van-field
        label="收货人"
        placeholder="请填写收货人姓名"
        name="recipient_name"
        v-model="name"
        :rules="[{ required: true, message: '请填写收货人姓名' }]"
      />
      <van-field
        label="手机号"
        placeholder="请填写收货人手机号"
        name="recipient_phone_number"
        v-model="phone"
        :rules="[
          { required: true, message: '请填写收货人手机号' },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: '请输入正确的手机号',
          },
        ]"
      />
      <van-field
        label="所在地区"
        placeholder="省、市、区"
        name="province"
        readonly
        @click="showArea = true"
        :rules="[{ required: true, message: '请选择所在地区' }]"
        :value="`${province}${city}${state}`"
      />
      <van-field
        label="详细地址"
        placeholder="小区、门牌号"
        name="address"
        v-model="address"
        :rules="[{ required: true, message: '请填写详细地址' }]"
      />
    </van-form>
    <div class="address-btn" @click="handleConfirm">确认</div>
    <van-popup v-model="showArea" position="bottom" class="area-popup">
      <van-area
        :area-list="areaList"
        @confirm="addressConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>


<script>
import { defineComponent, ref, watch } from "@vue/composition-api";
import { areaList } from "@vant/area-data";
import Vue from "vue";

import { addUserAddress, editUserAddress } from "@/apis/matter";

const vm = Vue.prototype;

export default defineComponent({
  props: ["type", "editAddressInfo"],
  setup(props, { emit }) {
    const showArea = ref(false);
    const formRef = ref(null);
    const name = ref("");
    const phone = ref("");
    const address = ref("");
    const province = ref("");
    const city = ref("");
    const state = ref("");

    watch(
      props.editAddressInfo,
      (newVal) => {
        console.log(newVal);
        name.value = newVal.recipient_name;
        phone.value = newVal.recipient_phone_number;
        address.value = newVal.address;
        province.value = newVal.province || "";
        city.value = newVal.city || "";
        state.value = newVal.state || "";
      },
      {
        immediate: true,
      }
    );

    const addressConfirm = (value) => {
      province.value = value[0].name;
      city.value = value[1].name;
      state.value = value[2].name;
      showArea.value = false;
    };

    const handleConfirm = async () => {
      try {
        await formRef.value.validate();
        if (props.type === "add") {
          await addUserAddress({
            recipient_name: name.value,
            recipient_phone_number: phone.value,
            province: province.value,
            city: city.value,
            state: state.value,
            address: address.value,
          });
        } else {
          await editUserAddress(
            {
              recipient_name: name.value,
              recipient_phone_number: phone.value,
              province: province.value,
              city: city.value,
              state: state.value,
              address: address.value,
            },
            props.editAddressInfo.id
          );
        }
        vm.$toast(props.type === "add" ? "新增成功" : "编辑成功");
        emit("refresh");
        emit("toSelect");
      } catch (error) {
        console.log(error);
      }
    };

    const handleBack = () => {
      emit("toSelect");
    };

    return {
      showArea,
      areaList,
      formRef,
      name,
      phone,
      address,
      province,
      city,
      state,
      addressConfirm,
      handleConfirm,
      handleBack,
    };
  },
});
</script>

<style lang="less" scoped>
.address-form-container {
  position: relative;

  .arrow-left {
    position: absolute;
    left: 16px;
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  text-align: center;
}

.address-form {
  margin-top: 16px;

  /deep/ .van-field__label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 28px;
    height: 28px;
  }
  /deep/ .van-field__body {
    height: 28px;
  }
}

.address-btn {
  margin-top: 16px;
  height: 44px;
  background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
  border-radius: 21px;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  color: #6c3e0c;
  line-height: 44px;
  margin-bottom: 40px;
}

.area-popup {
  border-radius: 24px 24px 0px 0px;
}
</style>